import { colors } from '../../colors';
var card = {
  textColorDark: colors.charcoalGrey,
  textColorLight: colors.offWhite,
  bgColor: colors.white,
  bgColorHero: colors.white
};
export default card;